import React, { Component } from 'react';
import { connect } from 'react-redux';
import RedSocial from './redsocial'
import {Navbar, NavItem} from 'react-materialize';

class Menu extends Component {
  constructor(props){
    super(props)
    this.state = {
      menu:[],
      options:{
        edege: 'right'
      }
    }
  }

  componentWillReceiveProps(next_props) {
    if(next_props.menus !== this.state.menu){
      let menudata = next_props.menus.filter((itemdata) => {
        return itemdata.cat === this.props.slug
      })

      menudata = menudata.sort(function(a, b){return a.menu_order - b.menu_order})
      this.setState({
        menu: menudata
      });
    }
  }

  render() {

    return (
      <div>
        <Navbar right options={this.state.options}>
          <NavItem href='/'>Inicio</NavItem>
          {
            this.state.menu.map((item, i) => {  
              return (
                <NavItem key={i} href={item.url} className={(item.title === 'Terminos de uso')? 'hide-on-large-only':''}>{item.title}</NavItem>
              )
            })
          }
          <div className="social-mobile hide-on-large-only">
            <RedSocial />
          </div>
        </Navbar>
      </div>
    );
  }
}


function mapStateToProps (reducer){
  return {
    menus: reducer.menus
  }
}

function mapDispathToProps (dispatch){
  return {
  }
}

export default connect(mapStateToProps, mapDispathToProps)(Menu)



// WEBPACK FOOTER //
// ./src/Menu.js